import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { lccstate } from 'lcc-state';

import css from '../css/splash.m.css';

const factory = create({ theme, lccstate });

export const Splash = factory(({ middleware: { theme, lccstate } }) => {
	const { get, path } = lccstate;
	const title = get(path('title'));
	const product = get(path('product'));

	const themeCss = theme.classes(css);

	const splashimg = `${window.hcstatic.portal_cdn}/js/images/${product}-splash.png`;

	return v('div', { classes: [theme.variant(), themeCss.root] }, [
		v('img', {
			classes: [themeCss.splash],
			xqa: 'splash',
			alt: `${title} ${product}`,
			src: splashimg
		})
	]);
});
